import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { authService } from '../services/authService';

const Home = () => {
  const [user, setUser] = useState(authService.getUser());
  
  useEffect(() => {
    // Загружаем информацию о пользователе при монтировании компонента
    const loadUser = async () => {
      await authService.loadUserInfo();
      setUser(authService.getUser());
    };
    loadUser();
  }, []);
  
  const allCalculators = [
    { id: 'mercantilebrace', name: 'Mercantile Brace', path: '/mercantile-brace', description: 'X-Wind Commercial Property calculator (polunio16)' },
    { id: 'wdbbsatinwood', name: 'WDBB Satinwood', path: '/wdbb-satinwood', description: 'Wind/Hail Buydown calculator with comprehensive rating factors' },
    { id: 'wdbbhiscox', name: 'WDBB Hiscox', path: '/wdbb-hiscox', description: 'Coming soon', disabled: true },
    { id: 'cmr', name: 'CMR', path: '/cmr', description: 'Coming soon', disabled: true },
    { id: 'br', name: 'BR', path: '/br', description: 'Coming soon', disabled: true },
    { id: 'df', name: 'DF', path: '/df', description: 'Coming soon', disabled: true },
    { id: 'ho', name: 'HO', path: '/ho', description: 'Coming soon', disabled: true },
    { id: 'mercantile', name: 'Mercantile', path: '/mercantile', description: 'Coming soon', disabled: true },
    { id: 'vp', name: 'VP', path: '/vp', description: 'Coming soon', disabled: true }
  ];

  // Фильтруем калькуляторы на основе доступа пользователя
  const availableCalculators = allCalculators.filter(calc => {
    if (!user || !user.accessOnly || user.accessOnly.length === 0) {
      return false;
    }
    return user.accessOnly.includes(calc.id);
  });

  return (
    <div>
      <h1>Evolve Rating Calculator</h1>
      <div className="card mt-3">
        <h2>Welcome to the Evolve Rating Web Interface</h2>
        <p className="mt-3">
          This application provides a user-friendly interface for calculating insurance premiums 
          using various rating engines.
        </p>
        
        <h3 className="mt-3">Available Calculators:</h3>
        {availableCalculators.length > 0 ? (
          <ul style={{ marginLeft: '20px', marginTop: '10px' }}>
            {availableCalculators.map(calc => (
              <li key={calc.id}>
                {calc.disabled ? (
                  <span className="text-muted">
                    <strong>{calc.name}</strong> - {calc.description}
                  </span>
                ) : (
                  <>
                    <Link to={calc.path}>
                      <strong>{calc.name}</strong>
                    </Link>
                    {' - ' + calc.description}
                  </>
                )}
              </li>
            ))}
          </ul>
        ) : (
          <p style={{ marginLeft: '20px', marginTop: '10px', color: '#666' }}>
            No calculators are available for your account. Please contact your administrator to request access.
          </p>
        )}

        <h3 className="mt-3">Getting Started:</h3>
        <ol style={{ marginLeft: '20px', marginTop: '10px' }}>
          <li>Select a calculator from the navigation menu above</li>
          <li>Fill in the required information</li>
          <li>Click "Calculate Premium" to get your results</li>
        </ol>

        <div className="mt-3">
          <p className="text-muted">
            <strong>Note:</strong> This interface requires authentication. Make sure you have valid credentials 
            configured in the API settings.
          </p>
        </div>
      </div>
    </div>
  );
};

export default Home;